import { createContext, useContext, type ReactNode } from 'react';

const EditorPageContext = createContext<string | null>(null);

export function EditorPageProvider({ pageId, children }: { pageId: string; children: ReactNode }) {
  return <EditorPageContext.Provider value={pageId}>{children}</EditorPageContext.Provider>;
}

export function useEditorPageId(): string {
  const pageId = useContext(EditorPageContext);
  if (!pageId) {
    throw new Error('useEditorPageId must be used within EditorPageProvider');
  }
  return pageId;
}
